/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Breadcrumb from "../../../../Basis/Components/Breadcrumb";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";
import Belegart from "../../Queries/Belegart";
import BelegeUrlsBuilder from "../../Utils/BelegeUrlsBuilder";

export interface MandantBelegProvisionenBreadcrumbProps {
    belegart: Belegart;
    belegId: string;
}

export default function MandantBelegProvisionenBreadcrumb(props: MandantBelegProvisionenBreadcrumbProps) {
    const { t } = useTranslation();
    const url = BelegeUrlsBuilder.getBelegUrl(props.belegart, props.belegId);
    return <Breadcrumb
        url={url + "/provisionen"}
        caption={t(translationKeys.mandantBelegProvisionenBreadcrumb.provisionen)} />;
}
